import { days } from "./orderDatesUtils";
import DateTime from "luxon/src/datetime.js";

export default time => {
  const pickupTime = DateTime.fromISO(time);
  const weekday = pickupTime.weekday === 7 ? 0 : pickupTime.weekday;
  return `${pickupTime.toLocaleString()} | ${days[weekday]}`;
};
